import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
// import { UserPlus } from "tabler-icons-react";
// import LeaveRequestTable from "./components/tableLeaveRequest";
import LeaveTabs from "./components/tabs/tabs";
import LeaveRequestTable from "./components/tableLeaveRequest";

export default function LeaveRequest() {
  const [opened, setOpened] = useState(false);
  return (
    <Box p="lg">
      {/* <LeaveRequestTable /> */}
      <LeaveTabs />
    </Box>
  );
}
